import { useState } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "@/lib/api";
import { AuthShell, Field, PasswordInput, btnPrimary } from "@/components/AuthShell";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const navigate = useNavigate();
  const [pw, setPw] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (ev) => {
    ev.preventDefault();
    setError("");
    if (pw !== confirm) {
      setError("Konfirmasi kata sandi tidak cocok.");
      return;
    }
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: pw });
      toast.success("Kata sandi berhasil diatur ulang. Silakan masuk.");
      navigate("/login", { replace: true });
    } catch (e) {
      setError(formatApiErrorDetail(e.response?.data?.detail) || e.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell title="Atur Ulang Kata Sandi" subtitle="Buat kata sandi baru untuk mengamankan akun Anda.">
      {!token ? (
        <div className="text-sm text-red-700 bg-red-50 border border-red-200 rounded-lg px-3 py-2" data-testid="reset-invalid-token">
          Tautan tidak valid. Silakan minta ulang tautan reset.
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4" data-testid="reset-form">
          <Field label="Kata Sandi Baru">
            <PasswordInput required value={pw} onChange={(e) => setPw(e.target.value)} placeholder="Minimal 8 karakter" testId="reset-new-password-input" />
          </Field>
          <Field label="Ulangi Kata Sandi Baru">
            <PasswordInput required value={confirm} onChange={(e) => setConfirm(e.target.value)} placeholder="Ketik ulang kata sandi baru" testId="reset-confirm-password-input" />
          </Field>
          {error && <div className="text-sm text-red-700 bg-red-50 border border-red-200 rounded-lg px-3 py-2" data-testid="reset-error">{error}</div>}
          <button type="submit" disabled={loading} className={btnPrimary} data-testid="reset-submit-button">
            {loading && <Loader2 className="h-4 w-4 animate-spin" />}
            Simpan Kata Sandi Baru
          </button>
        </form>
      )}
      <div className="text-center mt-4">
        <Link to="/login" className="text-sm text-[#1e5ea5] hover:text-[#0f2847] font-medium" data-testid="reset-cancel-link">
          Kembali ke Halaman Masuk
        </Link>
      </div>
    </AuthShell>
  );
}
